import { createAxiosClient } from "@ntg/component-library/utilities";
import { useQuery } from "@tanstack/react-query";
import { ITwoFAPayload } from "../Declarations";

export const useQRCode = (payload: ITwoFAPayload & { SecretKey: string }, enabled: boolean) =>
    useQuery<string>({
        enabled: enabled,
        queryFn: async (): Promise<string> => {
            const axiosAuth = createAxiosClient("Auth");
            const response = await axiosAuth.post<string>(
                "/UILogin/GenerateQRCode",
                payload,
                {
                    headers: {
                        "Content-Type": "application/json",
                    },
                }
            );
            return response.data;
        },
        queryKey: ["generateQRCode", payload.UserID, payload.SecretKey],
    });
